import { ReactElement, useState } from 'react';
import { App, Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { guardedClient } from '../../../auth/api/clients';
import { refreshAllAdvisorsCache } from '../../../../states/statesUtil';

interface Props {
  advisorId: number;
  name: string;
}

const DeleteButton = ({ advisorId, name }: Props): ReactElement => {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const { message } = App.useApp();

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await guardedClient.advisors[':id'].$delete({
        param: { id: String(advisorId) },
      });
      void message.success('削除しました');
      refreshAllAdvisorsCache();
      void navigate('/advisors');
    } catch (error) {
      console.error('delete failed', error);
      void message.error('削除に失敗しました');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Popconfirm
      title={`営業担当者「${name}」を削除しますか？`}
      onConfirm={() => {
        void handleDelete();
      }}
      okText='削除'
      cancelText='キャンセル'
      okButtonProps={{ danger: true }}
    >
      <Button type='text' danger icon={<DeleteOutlined />} loading={deleting}>
        削除
      </Button>
    </Popconfirm>
  );
};

export default DeleteButton;
